import { Observable, Subject } from 'rxjs';

export class PinItemBindingMediator {
  private itemId: string;

  private markerClicked$: Subject<void> = new Subject();
  private searchItemClicked$: Subject<void> = new Subject();
  private itemClicked$: Subject<void> = new Subject();
  private resetAction$: Subject<void> = new Subject();

  public get markerClicked(): Observable<void> {
    return this.markerClicked$.asObservable();
  }

  public get searchItemClicked(): Observable<void> {
    return this.searchItemClicked$.asObservable();
  }

  public get itemClicked(): Observable<void> {
    return this.itemClicked$.asObservable();
  }

  public get resetAction(): Observable<void> {
    return this.resetAction$.asObservable();
  }

  public get clickedId(): string {
    return this.itemId;
  }

  public onMarkerClick(id: string): void {
    this.itemId = id;
    this.markerClicked$.next();
  }

  public onClearMarkerClick(): void {
    this.itemId = '';
    this.markerClicked$.next();
  }

  public onSearchItemClick(id: string): void {
    this.itemId = id;
    this.searchItemClicked$.next();
  }

  public clickItem(id: string) {
    this.itemId = id;
    this.itemClicked$.next();
  }

  /** Call this method when it necessary to reset the selected marker outside map-container.component. */
  public reset(): void {
    this.resetAction$.next();
  }
}
